/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
    SHOW_LOADER,
    HIDE_LOADER,
    SHOW_HIDE_USER_LOADER,
    SHOW_HIDE_ROLE_ASSIGNMENT_LOADER,
    SHOW_HIDE_BUILT_IN_POLICIES_LOADER
} from './types';

const initialState = {
    displayLoader: true,
    displayShowHideUserLoader: false,
    displayShowHideRoleAssignmentLoader: false,
    displayShowHideBuiltinPoliciesLoader: false,
}
export const loaderReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SHOW_LOADER:
            return {
                ...state,
                displayLoader: action.displayLoader
            }
        case HIDE_LOADER:
            return {
                ...state,
                displayLoader: action.displayLoader
            }
        case SHOW_HIDE_USER_LOADER:
            return {
                ...state,
                displayShowHideUserLoader: action.showHideUserLoader
            }
        case SHOW_HIDE_ROLE_ASSIGNMENT_LOADER:
            return {
                ...state,
                displayShowHideRoleAssignmentLoader: action.showHideRoleAssignmentLoader
                    }
        case SHOW_HIDE_BUILT_IN_POLICIES_LOADER:
            return {
                ...state,
                displayShowHideBuiltinPoliciesLoader: action.showHideBuiltinPoliciesLoader
            }
        default:
            return state;
    }
}